<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-01 15:15:13
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-06-09 14:26:30
 * @FilePath: /content-center/src/components/wiki/AuditInfoBaike.vue
-->
<template>
  <div class="auditInfo">
    <div class="auditName">
      {{ contentName }}
    </div>
    <div class="auditJob">{{ name }}{{ contentId }}</div>
  </div>
</template>
<script>
import publicTool from '@/utils/public';
export default {
  name: "auditInfo",
  props: ['actionType','contentId','contentName'],
  data () {
    return {
      name: '百科ID:',
    }
  },
}
</script>

<style scoped lang="scss">
.auditInfo {
  .auditName {
    width: auto !important;
    height: auto !important;
    padding: 40px 0 30px 24px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #262626;
  }

  .auditJob {
    margin-top: 10px;
    padding: 0px 0 30px 23px;
    font-family: PingFang-SC-Regular;
    font-size: 16px;
    color: #9a9a9a;
  }
}
</style>
